import React from "react";
import PropTypes from "prop-types";
import { Form, Table } from "react-bootstrap";
import CommentTableRowNew from "../CommentTableRow/CommentTableRowNew";
import CommentsTableSkeleton from "./CommentsTableSkeleton";
import "./CommentsTableNew.scss";

const CommentsTableNew = ({
  comments,
  commentIndex,
  dateFormatID,
  viewFiles,
  onDownloadingFiles,
  clipped,
  setFilesList,
  setCurrComment,
  setDocumentLst,
  docuType,
  setFormModal,
  labels,
}) => {
  return (
    <Form.Group className="assign-member">
      <div className="comment-table-container">
        <table className="comment-header-container">
          <thead>
            <tr>
              <th className="left-aligned comment-comment-column">Comments</th>
              <th className="left-aligned user-comment-column">Actioned by</th>
              <th className="left-aligned date-comment-column">Date/Time</th>
              <th className="left-aligned action-comment-column">Action</th>
              <th className="center-aligned attachment-comment-column">
                Attachments
              </th>
            </tr>
          </thead>
        </table>
        <div className="comments-row-container">
          <Table className="comments-table" id="topComments">
            <tbody className="comment-body-container">
              {
                comments?.length === 0 && 
                  <CommentsTableSkeleton />
              }
              {comments.map((comment, index) => (
                <CommentTableRowNew
                  key={`${comment.Id}_${comment.TaskId}`}
                  comment={comment}
                  commentIndex={commentIndex}
                  index={index}
                  dateFormatID={dateFormatID}
                  viewFiles={viewFiles}
                  onDownloadingFiles={onDownloadingFiles}
                  clipped={clipped}
                  setFilesList={setFilesList}
                  setCurrComment={setCurrComment}
                  setDocumentLst={setDocumentLst}
                  docuType={docuType}
                  setFormModal={setFormModal}
                  labels={labels}
                />
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    </Form.Group>
  );
};

CommentsTableNew.propTypes = {
  comments: PropTypes.array.isRequired,
  commentIndex: PropTypes.array.isRequired,
  dateFormatID: PropTypes.string.isRequired,
  viewFiles: PropTypes.func.isRequired,
  onDownloadingFiles: PropTypes.func.isRequired,
  clipped: PropTypes.func.isRequired,
  setFilesList: PropTypes.func,
  setCurrComment: PropTypes.func,
  setDocumentLst: PropTypes.func,
  docuType: PropTypes.number,
};

export default CommentsTableNew;
